export default "__VITE_ASSET__fdaa2bff__"